import React from "react";
// Components
import Status from "../../../../components/Table/Status/KetQuaQuanTrac"
import { Icon, Tooltip } from 'antd'
import DateView from "../../../../components/Common/View/DateView";
import RowTools from "../../../../components/Table/RowTools";
const columns = ({showDetail } = {}) =>
    [
        {
            // key: "Id",
            title: "#",
            dataIndex: "stt",
            width: "65px"
        },
        {
            // key: "",
            title: "Mẫu quan trắc",
            dataIndex: "dotquantrac_ten",
        },
        {
            title: "Ngày lấy mẫu",
            dataIndex: "ngaylaymau",
            render: (value, row) => <DateView value={value} />,
    
            isExportExcel: true
        },
        {
            // key: "",
            title: "Đợt quan trắc",
            dataIndex: "dot",
        },
        {
            // key: "",
            title: "Kỳ quan trẳc",
            dataIndex: "nam",
        },
        {
            title: "Trạng thái",
            dataIndex: "ketqua_danhgia",
            width: 130,
            render: (value, row) => (
                <Tooltip title={row.thongso_vuotnguongs}>
                    <div>
                        <Status value={value} trangthai={value} />
                    </div>
                </Tooltip>
            )
        },
        {
            key: "tools",
            title: "Thao tác",
            dataIndex: "tools",
            align: "center",
            width: 80,
            render: (value, row) => (
              <RowTools row={row} iconDelete={true} iconEdit={true} iconDetail ={true} showDetail={showDetail}/>
            )
          }
    ].map(col => ({
        ...col,
    }));

export default columns;
